import React,{useEffect,useMemo,useRef,useState} from "react";
import css from "./SearchBtn.module.css";
import {capitalize,fadeIn,fadeOut} from "vritra";
import {libexports} from "Resources";
import {GetStartedScreen} from "Routes";
import {magnifier0} from "Assets";


export default function SearchBtn(props){
    const {onToggle,searchBarShown}=props;
    const [searching,setSearching]=useState(searchBarShown);
    const libentries=useMemo(()=>searching&&getEntries(),[searching]);
    const [options,setOptions]=useState((!searchBarShown)&&libentries);
    const inputRef=useRef();
    useEffect(()=>{
        const fieldEl=document.querySelector(`.${css.field}`);
        if(searching){
            fadeIn(fieldEl,"flex",statics.fadeDuration);
            fieldEl.querySelector(":scope>input").focus();
        }
        else{
            fadeOut(fieldEl,100);
        }
        onToggle&&onToggle(searching);
    },[searching]);
    return (
        <div className={css.searchbtn}>
            <div 
                className={css.field}
                style={styles.field(options)}
            >
                <input 
                    ref={inputRef}
                    placeholder={language.findsomething+" ..."}
                    onInput={(event)=>{
                        const value=event.target.value.trim().toLowerCase();
                        setOptions(((!searchBarShown)||value)&&findEntries(libentries,value));
                    }}
                />
                {options&&
                    <ul className={css.options}>
                        {options.map(({id,name,libid,libname})=>(
                            <li 
                                key={id+(libname||libid)}
                                onClick={()=>{
                                    location.hash="#"+libid+"#"+id;
                                    inputRef.current.value="";
                                    setOptions();
                                }}
                            >
                                <p>{name||id}</p>
                                <span>{libname||libid}</span>
                            </li>
                        ))}
                    </ul>
                }
            </div>
            <img 
                className={`button ${css.icon}`} 
                alt="" src={magnifier0(textColor)}
                onClick={()=>{setSearching(!searching)}}
            />
        </div>
    )
}
SearchBtn.defaultProps={
    searchBarShown:false,
}

const statics=SearchBtn.statics={
    fadeDuration:350,
},styles={
    field:(options)=>options?{
        borderBottomLeftRadius:0,
        borderBottomRightRadius:0,
    }:undefined,
}

const findEntries=(entries,query)=>entries.filter(({id,name,libname})=>(
    id.toLowerCase().includes(query)||
    name?.toLowerCase().includes(query)||
    libname?.toLowerCase().includes(query)
));

const getEntries=()=>{
    const entries=[];
    for(const key in libexports){
        const library=libexports[key];
        const libname=library.name||library.id;
        function addEntries(items){
            items?.forEach(item=>{
                entries.push({
                    id:item.id,libname,
                    libid:key,
                });
                addEntries(item.entries);
            });
        }
        addEntries(library.docs);
    }
    GetStartedScreen.statics.entries.forEach(function addEntry(entry){
        const subentries=entry.entries||[entry];
        subentries.forEach(item=>{
            const {id}=item;
            entries.push({
                id,name:item.name,
                libid:"getstarted",
                libname:entry.name||entry.id,
            });
            item.entries&&addEntry(item);
        });
    });
    entries.sort((b,a)=>b.id.toLowerCase()>a.id.toLowerCase()?1:-1);
    entries.forEach(entry=>{
        entry.name=capitalize(entry.name||entry.id);
    });
    return entries;
} 
